import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/atoms/Button';

const ErrorPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="h-screen bg-surface-base flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-text-primary mb-4">¡Ups! Algo salió mal</h1>
        <p className="text-text-secondary mb-8">Lo sentimos, ocurrió un error inesperado.</p>
        <div className="space-y-4">
          <Button
            onClick={() => navigate('/')}
            variant="primary"
          >
            Ir al inicio
          </Button>
          <Button
            onClick={() => window.location.reload()}
            variant="secondary"
          >
            Recargar página
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
